// import axios from "axios"
// import ReactInputMask from "react-input-mask";
import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup } from 'reactstrap';
import LoadScreen from "../UI/LoadScreen";
import { useForm } from "react-hook-form"
import useToken from '../useToken';
import { useAddProductMutation, useGetProductParamsQuery } from "../../features/CallApi";
// import { useEffect } from "react";
import { withMask, withHookFormMask } from 'use-mask-input';
import { useEffect } from 'react';

export const ProductAdd = ({ refetch }) => {

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const { token } = useToken();
    const [modal, setModal] = useState(false);
    const { isLoading, data: productParams, refetch: refetchParams  } = useGetProductParamsQuery();
    const [photoType, setPhotoType] = useState();
    const [photo, setPhoto] = useState();
    const [image, setImage] = useState(null)
    const [addProduct, { isLoading: postIsloading }] = useAddProductMutation();
    const [requiredSNInput, setRequiredSNInput] = useState(false);

    useEffect(() => {refetchParams()}, [])

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader(event.target.files[0]);
            reader.onloadend = () => {
                setPhoto(reader.result)
                setPhotoType(event.target.files[0].type)
            }
            reader.readAsDataURL(event.target.files[0])
        }
    }

    const toggle = () => {
        setModal(!modal)
        setPhoto(null)
        reset()
    }

    const onRequiredSNChenge = (e) => {
        setRequiredSNInput(e.target.checked)
    }

    const setAddProduct = (data) => {
        data.requiredSN = requiredSNInput
        if (photo) {
            data.photo = photo
            data.photoType = photoType
        }
        console.log(data)
        addProduct(data).unwrap().then(() => {
            setRequiredSNInput(false)
            setModal(!modal)
            setPhoto(null)
            reset()
            refetch()
        }).catch((e) => {
        })
    }

    return (
        <div>
            <Button className='mb-2' color="success" size="sm" onClick={toggle}>
                Создать товар
            </Button>
            <Modal isOpen={modal} toggle={toggle} size={"xl"}>
                <ModalHeader toggle={toggle}>Создать товар</ModalHeader>
                {isLoading ? <LoadScreen></LoadScreen> : <form className="" onSubmit={handleSubmit(setAddProduct)}>
                    <ModalBody>
                        {productParams ?
                            <div className="row">
                                <div className="col-xl">
                                    <div className="mb-1">
                                        <label htmlFor="category" className="form-label">Категория</label>
                                        <select id="category" name="category" defaultValue={null} className="form-select" placeholder={`Выберите категорию`}
                                            {...register("category", { required: { value: true, message: "Выберите категорию" } })} >
                                            {productParams.category ?
                                                productParams.category.map(category =>
                                                    <option key={category.id} value={category.id}>{category.name}</option>
                                                ) : <option disabled>Нет доступных категорий</option>}
                                        </select>
                                        {errors.category && <span className='text-danger'>{errors.category?.message}</span>}
                                    </div>
                                    <div className="mb-1">
                                        <label htmlFor="agent" className="form-label">Агент</label>
                                        <select id="agent" name="agent" defaultValue={""} className="form-select"
                                            {...register("agent")} >
                                            <option value="0">--- Агент не выбран ---</option>
                                            {productParams.agent ?
                                                productParams.agent.map(agent =>
                                                    <option key={agent.id} value={agent.id}>{agent.name} (ИНН: {agent.tin})</option>
                                                ) : <option disabled>Нет доступных агентов</option>}
                                        </select>
                                    </div>
                                    <div className="mb-1">
                                        <label htmlFor="name" className="form-label">Наименование</label>
                                        <input id="name" name="name" className="form-control"
                                            {...register("name", { required: { value: true, message: "Укажите наименование" } })} />
                                        {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                                    </div>
                                    <div className="mb-1">
                                        <label htmlFor="sku" className="form-label">Артикул</label>
                                        <input id="sku" ref={withMask('99999999')} name="sku" className="form-control"
                                            {...withHookFormMask({ ...register("sku", { required: { value: true, message: "Укажите артикул" } }) }
                                                , ['9999999', '99999999'])} />
                                        {errors.sku && <span className='text-danger'>{errors.sku?.message}</span>}
                                    </div>
                                    <div className="mb-1">
                                        <label htmlFor="price" className="form-label">Цена</label>
                                        <input id="price" name="price" step={.01} type={"number"} className="form-control"
                                            {...register("price", { required: { value: true, message: "Укажите цену" } })} />
                                        {errors.price && <span className='text-danger'>{errors.price?.message}</span>}
                                    </div>
                                    <div className="row mb-1">
                                        <div className="col-md">
                                            <div className="mb-1">
                                                <label htmlFor="typeProduct" className="form-label">Тип продукта</label>
                                                <select id="typeProduct" name="typeProduct" defaultValue={""} className="form-select"
                                                    {...register("typeProduct")} >
                                                    {productParams.typeProduct ?
                                                        productParams.typeProduct.map(typeProduct =>
                                                            <option key={typeProduct.id} value={typeProduct.id}>{typeProduct.name}</option>
                                                        ) : <option disabled>Нет доступных категорий</option>}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div className="mb-1">
                                                <label htmlFor="taxProduct" className="form-label">Налоговая ставка</label>
                                                <select id="taxProduct" name="taxProduct" defaultValue={""} className="form-select"
                                                    {...register("taxProduct")} >
                                                    {productParams.taxProduct ?
                                                        productParams.taxProduct.map(taxProduct =>
                                                            <option key={taxProduct.id} value={taxProduct.id}>{taxProduct.name}</option>
                                                        ) : <option disabled>Нет доступных категорий</option>}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div className="mb-1">
                                                <label htmlFor="calculationMethod" className="form-label">Метод расчета</label>
                                                <select id="calculationMethod" name="calculationMethod" defaultValue={""} className="form-select"
                                                    {...register("calculationMethod")} >
                                                    {productParams.calculationMethod ?
                                                        productParams.calculationMethod.map(calculationMethod =>
                                                            <option key={calculationMethod.id} value={calculationMethod.id}>{calculationMethod.name}</option>
                                                        ) : <option disabled>Нет доступных категорий</option>}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-2 d-flex">
                                        <div className=" form-check form-switch">
                                            <label className="form-check-label">Требует серийный номер</label>
                                            <input onClick={(e) => onRequiredSNChenge(e)} type="checkbox"
                                                className="form-check-input check-input-lc" {...register("requiredSN")} />
                                        </div>
                                    </div>
                                    <div className={`mb-1 ${requiredSNInput ? "" : "d-none"}`}>
                                        <label htmlFor="maskSN" className="form-label">Маска серийного номера</label>
                                        <input id="maskSN" name="maskSN" type="text" className="form-control"
                                            {...register("maskSN")} />
                                        {errors.maskSN && <span className='text-danger'>{errors.maskSN?.message}</span>}
                                    </div>
                                </div>
                                <div className="col-xl">
                                    <label htmlFor="photo" className="form-label">Изображение продукта</label>
                                    <div className="card mb-3">
                                        <div className="mb-3 text-center">
                                            <img src={photo ? `${photo}` : `/Content/img/NoPhoto.png`} className="img-fluid" alt="Product photo" />
                                        </div>
                                    </div>
                                    <div>
                                        <input onChange={onImageChange}
                                            id="photo"
                                            name="photo"
                                            className="form-control form-control-sm"
                                            accept=".jpg, .jpeg, .png" type="file" />
                                    </div>
                                </div>
                            </div> : <LoadScreen />
                        }
                    </ModalBody>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button color="success">
                                Добавить
                            </Button>
                            <Button color="warning" onClick={toggle}>
                                Отмена
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </form>
                }
            </Modal>
        </div>
    )
}